define(['angular'], function(angular) {


    /**
     * @class FlashupService
     */
    function FlashupService() {
        var self = this;

        self.amountPerPack = 45;

        /**
         * Return a boolean value based on flashup option
         * @method isFlashupBoxIncluded
         * @param  {Object} flashup option
         * @return {Boolean}
         */
        self.isFlashupBoxOption = function isFlashupBoxOption(flashup) {
            var flashupWithBoxOption = self.findFlashupOption([flashup], false);
            return flashupWithBoxOption ? flashupWithBoxOption.id === flashup.id : false;
        };

        return self;
    }

    FlashupService.$inject = [];

    angular.module('app.bdc.common.flashupService', []).factory('flashupService', FlashupService);
});
